<template>
  <div class="p-3"  :class="{ 'raised rounded': raised }">
    <div v-if="noAddresses" class="text-center">
      There is no Business/Mailing address registered for this Entity!
    </div>
    <div v-else>
      <div
        :class="`pl-3 pr-3 pb-${addresses.length > 1 ? '3' : '2'}`"
        v-for="obj in addresses"
        v-bind:key="obj.title"
      >
        <simple-title :title="obj.title" />
        <address-display :address="obj.address"/>
        <div v-if="obj.hint" class="text-right small mt-3">
          {{ obj.hint }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddressDisplay from '@/components/utils/address/AddressDisplay';
import SimpleTitle from '@/components/utils/SimpleTitle';

export default {
  components: {
    AddressDisplay,
    SimpleTitle,
  },
  props: {
    entity: {
      type: Object,
      required: true,
    },
    raised: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    noAddresses() {
      return (
        this.entity &&
        this.entity.businessAddress === null &&
        this.entity.mailingAddress === null
      );
    },
    sameAddress() {
      if (!this.entity) { return false; }

      const bAddress = this.entity.businessAddress;
      const mAddress = this.entity.mailingAddress;
      return !Object.keys(bAddress).some(key => bAddress[key] !== mAddress[key]);
    },
    addresses() {
      if (!this.entity || this.noAddresses) { return []; }

      const businessAddress = {
        title: 'Business Address',
        address: this.entity.businessAddress,
        hint: this.sameAddress ? '*This is also the mailing address.' : null,
      };
      const allAddresses = [businessAddress];

      if (!this.sameAddress) {
        allAddresses.push({
          title: 'Mailing Address',
          address: this.entity.mailingAddress,
        });
      }

      return allAddresses;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/entities/EntityAddress.vue